import { motion } from 'framer-motion';
import { ArrowDown, ArrowUp, Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/card';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

export const StatCard = ({ label, value, delta, deltaType = 'up', helper, sparkline, info, testId }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.24 }}
    >
      <Card
        data-testid={testId || 'dashboard-stat-card'}
        className="p-5 bg-[hsl(var(--card))] border-border hover:-translate-y-[1px] hover:shadow-card transition-shadow"
      >
        <div className="flex items-center justify-between">
          <div className="text-xs font-medium text-muted-foreground tracking-wide uppercase">{label}</div>
          {info && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button type="button" aria-label="info" className="text-muted-foreground hover:text-foreground">
                    <Info className="h-3.5 w-3.5" />
                  </button>
                </TooltipTrigger>
                <TooltipContent>{info}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        <div className="mt-2.5 flex items-baseline gap-2">
          <span data-testid="dashboard-stat-value" className="font-display text-2xl md:text-3xl font-semibold tracking-tight">
            {value}
          </span>
          {delta !== undefined && (
            <span
              className={cn(
                'inline-flex items-center gap-0.5 text-xs font-medium px-1.5 py-0.5 rounded-md',
                deltaType === 'up'
                  ? 'text-emerald-600 bg-emerald-500/10 dark:text-emerald-400'
                  : 'text-rose-600 bg-rose-500/10 dark:text-rose-400'
              )}
            >
              {deltaType === 'up' ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}
              {delta}
            </span>
          )}
        </div>
        {helper && <div className="mt-1 text-xs text-muted-foreground">{helper}</div>}
        {sparkline && <div className="mt-3">{sparkline}</div>}
      </Card>
    </motion.div>
  );
};
